/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import './polyfill';

import Vue from 'vue';

import AppRoot from './app-root';
import FingerprintHardware from './fingerprint/fingerprint-hardware';
import FingerprintHasher from './fingerprint/fingerprint-hasher';
import GeneratorFirmwareManager from './generator/generator-firmware-manager';
import GeneratorNetworkManager from './generator/generator-network-manager';
import NetworkConnection from './network/network-connection';
import NetworkConnectionFactory from './network/network-connection-factory';

const firmwareManager = new GeneratorFirmwareManager();
const fingerprintHasher = new FingerprintHasher();
const networkManager = new GeneratorNetworkManager();
const fingerprintManager = new FingerprintHardware(firmwareManager, fingerprintHasher, networkManager);
const networkConnectionFactory = new NetworkConnectionFactory(NetworkConnection);

Vue.config.productionTip = false;

// eslint-disable-next-line no-new
new Vue({
  components: {AppRoot},
  created () {
    this.fingerprintManager = fingerprintManager;
    this.firmwareManager = firmwareManager;
    this.networkConnectionFactory = networkConnectionFactory;
    this.networkManager = networkManager;
  },
  el: '#app',
  template: '<AppRoot/>'
});
